import { EuiButton } from '@equipmentshare/ds2'

import PermissionsCheck from '../../../../../../../components/PermissionsCheck'
import { Provider, Permission } from '../../../../../../../graphql'

import { getEditModal, getMergeModal } from '../../../../components/actionModals'
import { useDispatchSetSelectedModal } from '../../../../../../../contexts/modal-context/modal-context'

import { heapEvent } from '@equipmentshare/heaper'

export type EditActionProps = {
	provider: Provider,
}

export default function EditAction( { provider }: EditActionProps ) {
	const setSelectedModal = useDispatchSetSelectedModal()

	const openMergeModal = () => {
		heapEvent( 'Inventory - Edit Manufacturer Modal - Click - Merge Manufacturers', {} )
		setSelectedModal( getMergeModal( provider ) )
	}
	const openEditModal = () => {
		heapEvent( 'Inventory - Manufacturer Catalog - Click - Edit', {} )
		setSelectedModal( getEditModal( provider, openMergeModal ) )
	}

	return (
		<PermissionsCheck permissionsToCheck={[ Permission.CanEditProvider ]}>
			<EuiButton
				color="text"
				onClick={openEditModal}
			>
				Edit
			</EuiButton>
		</PermissionsCheck>
	)
}
